import {FC, PropsWithChildren} from "react";

import {QueryClient, QueryClientProvider} from "@tanstack/react-query";

import {defaultOptions} from "./queryClient";

const queryClient = new QueryClient({defaultOptions});

export const ReactQueryProvider: FC<PropsWithChildren> = ({children}) => {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};
